var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import * as actionTypes from './constants';
import { getSelectedOrganizationId } from './utils';
import { LOAD_FILES_FAILURE, LOAD_FILES_REQUEST, LOAD_FILES_SUCCESS, } from '../ViewBuilder/constants';
import { PLATFORM_VERSION_REQUEST, PLATFORM_VERSION_SUCCESS, PLATFORM_VERSION_FAILURE, SET_OPEN_APP, } from './constants';
// The initial state of the App
export var getInitialState = function () { return ({
    username: '',
    require2FA: false,
    initialized: false,
    loading: true,
    me: false,
    authentication_request: false,
    authentication_error: false,
    apps: [],
    appOpen: { lastUrl: '/apps', appId: null },
    categories: [],
    templates: [],
    template: {},
    apps_meta: {},
    selectedAppId: '',
    mainMenuState: true,
    secondaryMenuState: true,
    loadingApps: false,
    appsLoaded: false,
    allOrgApps: [],
    orgApps: [],
    loadingAllOrgApps: false,
    allOrgAppsLoaded: false,
    organizations: [],
    organizationsInitialized: false,
    appOrganizations: [],
    selectedOrganizationId: '',
    override: true,
    resetPassword: {},
    resetPassword_request: false,
    resetPassword_error: false,
    deleteApp_request: false,
    deleteApp_error: false,
    savePassword_request: false,
    savePassword_error: false,
    createApp_error: false,
    files: [],
    filesMeta: {},
    paginationIndexes: {},
    platformVersion: { major: 0, minor: 16, patch: 0 },
    paymentDetails: {
        customerCard: undefined,
        customerCardLoading: false,
        customerCardError: false,
    },
    sidebarState: {
        main: false,
    },
    searchString: '',
    checkLoading: false,
    appsDetails: [],
    patchesDetails: [],
    viewsDetails: [],
}); };
function rootReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        var _a, _b, _c;
        switch (action.type) {
            case actionTypes.SELECT_ORGANIZATION:
                if (!action.selectedOrganizationId ||
                    state.organizations.some(function (organizationId) { return organizationId === action.organizationId; })) {
                    state.selectedOrganizationId = action.organizationId;
                }
                break;
            case actionTypes.LOAD_USER_ORGANIZATIONS: {
                state.organizations = action.organizations;
                if (action.organizations && action.organizations.length > 0) {
                    if (!state.selectedOrganizationId ||
                        !state.organizations.some(function (organizationId) { return organizationId === action.organizationId; })) {
                        state.selectedOrganizationId = getSelectedOrganizationId(action.organizations);
                    }
                }
                state.organizationsInitialized = true;
                break;
            }
            case actionTypes.LOAD_APP_WRITE_ORGANIZATIONS: {
                state.appOrganizations = action.organizations;
                if (action.organizations && action.organizations.length > 0) {
                    if (!state.selectedOrganizationId ||
                        !state.appOrganizations.some(function (organizationId) { return organizationId === action.organizationId; })) {
                        state.selectedOrganizationId = getSelectedOrganizationId(action.organizations);
                    }
                }
                break;
            }
            case actionTypes.LOAD_LATEST_POLICY:
                state.latestPolicy = action.latestPolicy;
                break;
            case actionTypes.LOAD_LATEST_TERM:
                state.latestTerm = action.latestTerm;
                break;
            case actionTypes.LOAD_USER_GROUPS:
                state.groups = action.groups;
                break;
            case actionTypes.LOGIN_REQUEST:
                state.authentication_request = true;
                state.authentication_error = false;
                break;
            case actionTypes.LOGIN_REQUEST_2FA:
                state.authentication_request = true;
                state.authentication_error = false;
                state.require2FA = true;
                break;
            case actionTypes.LOGIN_SUCCESS:
                state.authentication_request = false;
                state.authentication_error = false;
                state.username = action.email;
                break;
            case actionTypes.LOGIN_FAILED:
                state.authentication_request = false;
                state.authentication_error = true;
                break;
            case actionTypes.LOAD_USER_PROFILE:
                state.me = action.me;
                break;
            case actionTypes.SIGNAL_ROOT_INITIALIZED:
                state.initialized = true;
                break;
            case actionTypes.LOGOUT:
                state = Object.assign(state, getInitialState());
                break;
            case actionTypes.SIGNUP_FAILED:
                state.signup_error = true;
                break;
            case actionTypes.RESET_PASSWORD_REQUEST:
                state.resetPassword_request = true;
                state.resetPassword_error = false;
                break;
            case actionTypes.RESET_PASSWORD_SUCCESS:
                state.resetPassword_request = false;
                state.resetPassword_error = false;
                break;
            case actionTypes.RESET_PASSWORD_FAILED:
                state.resetPassword_request = false;
                state.resetPassword_error = true;
                break;
            case actionTypes.GET_TEMPLATE_CATEGORIES:
                state.loading = true;
                state.categories = [];
                break;
            case actionTypes.GET_TEMPLATE_CATEGORIES_SUCCESS:
                state.loading = false;
                state.categories = action.categories;
                break;
            case actionTypes.GET_TEMPLATE_CATEGORIES_FAILED:
                state.loading = false;
                state.categories = [];
                break;
            case actionTypes.CREATE_TEMPLATE_CATEGORY:
                state.loading = true;
                break;
            case actionTypes.CREATE_TEMPLATE_CATEGORY_SUCCESS:
                state.loading = false;
                state.categories = action.addedCategory
                    ? __spreadArray(__spreadArray([], state.categories, true), [action.addedCategory], false) : state.categories;
                break;
            case actionTypes.CREATE_TEMPLATE_CATEGORY_FAILED:
                state.loading = false;
                break;
            case actionTypes.UPDATE_TEMPLATE_CATEGORY:
                state.loading = true;
                break;
            case actionTypes.UPDATE_TEMPLATE_CATEGORY_SUCCESS:
                state.loading = false;
                state.categories = state.categories.map(function (cat) {
                    if (cat.id === action.updatedCategory.id) {
                        return action.updatedCategory;
                    }
                    return cat;
                });
                break;
            case actionTypes.UPDATE_TEMPLATE_CATEGORY_FAILED:
                state.loading = false;
                break;
            case actionTypes.DELETE_TEMPLATE_CATEGORY:
                state.loading = true;
                break;
            case actionTypes.DELETE_TEMPLATE_CATEGORY_SUCCESS:
                state.loading = false;
                state.categories = state.categories.filter(function (cat) { return cat.id !== action.categoryId; });
                break;
            case actionTypes.DELETE_TEMPLATE_CATEGORY_FAILED:
                state.loading = false;
                break;
            case actionTypes.CREATE_APP_TEMPLATE:
                state.loading = true;
                break;
            case actionTypes.CREATE_APP_TEMPLATE_SUCCESS:
                state.loading = false;
                state.templates = ((_a = state.templates) === null || _a === void 0 ? void 0 : _a.length)
                    ? __spreadArray(__spreadArray([], state.templates, true), [action.newTemplate], false) : [action.newTemplate];
                break;
            case actionTypes.CREATE_APP_TEMPLATE_FAILED:
                state.loading = false;
                break;
            case actionTypes.GET_APP_TEMPLATES:
                state.loading = true;
                state.templates = [];
                break;
            case actionTypes.GET_APP_TEMPLATES_SUCCESS:
                state.loading = false;
                state.templates = action.templates;
                break;
            case actionTypes.GET_APP_TEMPLATES_FAILURE:
                state.loading = false;
                break;
            case actionTypes.DELETE_APP_TEMPLATES:
                state.loading = true;
                break;
            case actionTypes.DELETE_APP_TEMPLATES_SUCCESS:
                state.loading = false;
                state.templates = state.templates.filter(function (temp) { return temp.id !== action.templateId; });
                state.template = {};
                break;
            case actionTypes.DELETE_APP_TEMPLATES_FAILURE:
                state.loading = false;
                break;
            case actionTypes.UPDATE_APP_TEMPLATE:
                state.loading = true;
                break;
            case actionTypes.UPDATE_APP_TEMPLATE_SUCCESS:
                state.loading = false;
                state.templates = state.templates.map(function (temp) {
                    if (temp.id === action.updatedTemplate.id) {
                        return action.updatedTemplate;
                    }
                    return temp;
                });
                break;
            case actionTypes.UPDATE_APP_TEMPLATE_FAILED:
                state.loading = false;
                break;
            case actionTypes.GET_TEMPLATE_DATA:
                state.loading = true;
                state.template = {};
                break;
            case actionTypes.GET_TEMPLATE_DATA_SUCCESS:
                state.loading = false;
                state.template = action.templateData;
                break;
            case actionTypes.GET_TEMPLATE_DATA_FAILURE:
                state.loading = false;
                state.template = {};
                break;
            case actionTypes.LOAD_APPS:
                state.loadingApps = true;
                state.appsLoaded = false;
                break;
            case actionTypes.LOAD_APPS_SUCCESS:
                state.loadingApps = false;
                state.apps = action.apps;
                state.apps_meta = action.meta;
                state.appsLoaded = true;
                break;
            case actionTypes.LOAD_APPS_EMPTY_SUCCESS: {
                state.loadingApps = false;
                var appIndex = (_b = currentState.apps) === null || _b === void 0 ? void 0 : _b.findIndex(function (app) { return app.id === action.app.id; });
                if (appIndex > -1 && state.apps[appIndex]) {
                    state.apps[appIndex] = action.app;
                }
                break;
            }
            case actionTypes.LOAD_APPS_FAILED:
                state.loadingApps = false;
                state.appsLoaded = false;
                break;
            case actionTypes.LOAD_ALL_ORG_APPS:
                state.loadingAllOrgApps = true;
                state.allOrgAppsLoaded = false;
                break;
            case actionTypes.LOAD_ALL_ORG_APPS_SUCCESS:
                state.loadingAllOrgApps = false;
                state.allOrgApps = action.apps;
                state.allOrgAppsLoaded = true;
                break;
            case actionTypes.LOAD_ALL_ORG_APPS_FAILED:
                state.loadingAllOrgApps = false;
                state.allOrgAppsLoaded = false;
                break;
            case actionTypes.LOAD_ORG_APPS:
                state.loadingAllOrgApps = true;
                state.allOrgAppsLoaded = false;
                break;
            case actionTypes.LOAD_ORG_APPS_SUCCESS:
                state.loadingAllOrgApps = false;
                state.orgApps = action.apps;
                state.allOrgAppsLoaded = true;
                break;
            case actionTypes.LOAD_ORG_APPS_FAILED:
                state.loadingAllOrgApps = false;
                state.allOrgAppsLoaded = false;
                break;
            case actionTypes.LOAD_USAGE_APP:
                state.checkLoading = true;
                break;
            case actionTypes.LOAD_USAGE_APP_SUCCESS:
                state.checkLoading = false;
                state.appsDetails = (action === null || action === void 0 ? void 0 : action.appsDetails) || [];
                state.patchesDetails = (action === null || action === void 0 ? void 0 : action.patchesDetails) || [];
                state.viewsDetails = (action === null || action === void 0 ? void 0 : action.viewsDetails) || [];
                break;
            case actionTypes.LOAD_USAGE_APP_FAILED:
                state.checkLoading = false;
                break;
            case actionTypes.CREATE_APP:
                state.loadingApps = true;
                state.createApp_error = false;
                break;
            case actionTypes.CREATE_APP_SUCCESS:
                state.createApp_error = false;
                state.loadingApps = false;
                state.apps = __spreadArray(__spreadArray([], (state.apps || []), true), [action.app], false);
                break;
            case actionTypes.CREATE_APP_FAILED:
                state.loadingApps = false;
                state.createApp_error = true;
                break;
            case actionTypes.UPDATE_APP:
                state.loadingApps = true;
                break;
            case actionTypes.UPDATE_APP_SUCCESS: {
                state.loadingApps = false;
                break;
            }
            case actionTypes.UPDATE_APP_FAILED:
                state.loadingApps = false;
                break;
            case actionTypes.UPDATE_DASHBOARD: {
                if (state.me) {
                    state.me.dashboard = action.dashboard;
                }
                break;
            }
            case actionTypes.GO_TO_APP_DETAIL:
                state.selectedAppId = action.appId;
                break;
            case actionTypes.SECONDARY_SIDEBAR_STATE:
                state.secondaryMenuState = action.secondaryMenuState;
                break;
            case actionTypes.MAIN_SIDEBAR_STATE:
                state.mainMenuState = action.mainMenuState;
                break;
            case actionTypes.DELETE_APP_REQUEST:
                state.deleteApp_request = true;
                state.deleteApp_error = false;
                break;
            case actionTypes.DELETE_APP_SUCCESS:
                state.deleteApp_request = false;
                state.deleteApp_error = false;
                break;
            case actionTypes.DELETE_APP_FAILURE:
                state.deleteApp_request = false;
                state.deleteApp_error = true;
                break;
            case actionTypes.SAVE_PASSWORD_REQUEST:
                state.savePassword_request = true;
                state.savePassword_error = false;
                break;
            case actionTypes.SAVE_PASSWORD_SUCCESS:
                state.savePassword_request = false;
                state.savePassword_error = false;
                break;
            case actionTypes.SAVE_PASSWORD_FAILURE:
                state.savePassword_request = false;
                state.savePassword_error = true;
                break;
            case actionTypes.SET_PAGINATION:
                state.paginationIndexes[action.paginationName] = action.paginationIndex;
                break;
            case actionTypes.SET_MODAL_VISIBILITY_OVERRIDE:
                state.override = action.override;
                break;
            case LOAD_FILES_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_FILES_SUCCESS:
                state.files = action.files;
                state.icons = action.icons;
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_FILES_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case PLATFORM_VERSION_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case PLATFORM_VERSION_SUCCESS:
                state.platformVersion = action.version;
                state.loading = false;
                state.error = false;
                break;
            case PLATFORM_VERSION_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case 'PaymentModal/CARD_CHECK_REQUEST':
                state.paymentDetails.customerCardLoading = true;
                state.paymentDetails.customerCardError = false;
                break;
            case 'PaymentModal/CARD_CHECK_SUCCESS':
                state.paymentDetails.customerCardLoading = false;
                state.paymentDetails.customerCardError = false;
                state.paymentDetails.defaultPaymentMethod =
                    action.action.default_payment_method;
                state.paymentDetails.customerCard = action.action.card_payment_method;
                break;
            case 'PaymentModal/CARD_CHECK_FAILURE':
                state.paymentDetails.customerCardLoading = false;
                state.paymentDetails.customerCardError = true;
                state.paymentDetails.defaultPaymentMethod = undefined;
                state.paymentDetails.customerCard = undefined;
                break;
            case SET_OPEN_APP:
                state.appOpen = action.payload;
                break;
            case actionTypes.SET_MAIN_SIDEBAR_STATE:
                state.sidebarState.main = action.state;
                break;
            case actionTypes.SET_SEARCH_STRING:
                state.searchString = action.searchString;
                break;
            case actionTypes.UPDATE_ORG_TYPE:
                state.organizations.find(function (org) { return org.id === action.orgId; }).type =
                    action.orgType;
                break;
            case actionTypes.UPDATE_APP_FAVOURITE:
                {
                    var appIndex = (_c = currentState.apps) === null || _c === void 0 ? void 0 : _c.findIndex(function (app) { return app.id === action.appId; });
                    if (appIndex > -1 && state.apps[appIndex]) {
                        state.apps[appIndex].is_favourite = action.isFavourite;
                    }
                }
                break;
            default:
                break;
        }
    });
}
export default rootReducer;
